import { isEmpty } from 'lodash';
import { Stack } from '../../../shared/layouts';
import CompanyBlock from './CompanyBlock';
import AddressesBlock from './AddressesBlock';
import ReportIncorrectDataLink from '../../../shared/ReportIncorrectDataLink';
import ContactPersonsBlock from "./ContactPersonsBlock";

const CompanyProfile = ({ companyData, applicantData, addressesWithType }) => {
  let contactPersons = companyData?.contact_persons || [];

  // Fallback to applicant data if existing.
  if (isEmpty(contactPersons) && (!isEmpty(applicantData?.email) || !isEmpty(applicantData?.phone_number))) {
    contactPersons = [
      {
        email: applicantData?.email,
        phone_number: applicantData?.phone_number,
      }
    ];
  }
  return (
    <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
      <CompanyBlock company={companyData} applicantData={applicantData} />

      {!isEmpty(addressesWithType) && (
        <AddressesBlock addresses={addressesWithType} />
      )}

      {!isEmpty(contactPersons) && (
        <ContactPersonsBlock contact_persons={contactPersons} />
      )}

      <ReportIncorrectDataLink />
    </Stack>
  );
};

export default CompanyProfile;
